import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../static/upload.png'


const _withScopeId = n => (_pushScopeId("data-v-1d733245"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("上传")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("初中及以下")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("高中、中专")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("大专")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("本科")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("硕士")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("博士")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("MBA/EMBA")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("不限")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#ccc"} }, "——", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "用户基本信息", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "姓名"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "工作经验"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "邮箱"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "地址"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "优势")
], -1))
const _hoisted_20 = { style: {"display":"flex"} }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { class: "item" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { style: {"margin-top":"30px"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "教育经历", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "学校"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "专业"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "学历"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "描述"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "时间")
], -1))
const _hoisted_29 = { style: {"display":"flex"} }
const _hoisted_30 = { class: "item" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = { class: "item" }
const _hoisted_33 = { class: "item" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_35 = { class: "item" }
const _hoisted_36 = { style: {"margin-top":"30px"} }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "期望工作", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "职位"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "薪资"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "地区"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "行业"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "创建时间")
], -1))
const _hoisted_39 = { style: {"display":"flex"} }
const _hoisted_40 = { class: "item" }
const _hoisted_41 = { class: "item" }
const _hoisted_42 = { class: "item" }
const _hoisted_43 = { class: "item" }
const _hoisted_44 = { class: "item" }
const _hoisted_45 = { style: {"margin-top":"30px"} }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "工作经历", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "公司名"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "职位"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "工作内容"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "入职日期"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "离职日期")
], -1))
const _hoisted_48 = { style: {"display":"flex"} }
const _hoisted_49 = { class: "item" }
const _hoisted_50 = { class: "item" }
const _hoisted_51 = { class: "item" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_53 = { class: "item" }
const _hoisted_54 = { class: "item" }
const _hoisted_55 = { style: {"margin-top":"30px"} }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "项目经验", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "项目名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "职责"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "业绩"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "描述"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "开始日期"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "结束日期")
], -1))
const _hoisted_58 = { style: {"display":"flex"} }
const _hoisted_59 = { class: "item" }
const _hoisted_60 = { class: "item" }
const _hoisted_61 = { class: "item" }
const _hoisted_62 = { class: "item" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_64 = { class: "item" }
const _hoisted_65 = { class: "item" }
const _hoisted_66 = { style: {"margin-top":"30px"} }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "证书", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "item item2",
    style: {"width":"50%"}
  }, "id"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "item item2",
    style: {"width":"50%"}
  }, "证书名称")
], -1))
const _hoisted_69 = { style: {"display":"flex"} }
const _hoisted_70 = {
  class: "item",
  style: {"width":"50%"}
}
const _hoisted_71 = {
  class: "item",
  style: {"width":"50%"}
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-drag-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"20%"}
  })
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"20px"} }, " 请上传word格式文件 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, { title: "简历管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.upResume
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          autocomplete: "off",
          layout: "inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "姓名",
                  value: _ctx.searches.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.searches.education,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.education) = $event)),
                  style: {"width":"200px"},
                  placeholder: "学历"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "2" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "3" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "4" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "5" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "6" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "7" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.searches.work_age,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.work_age) = $event)),
                  placeholder: "工作经验"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.searches.position_id,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searches.position_id) = $event)),
                  allowClear: "",
                  style: {"width":"200px"},
                  placeholder: "期待工作",
                  onChange: _ctx.Change,
                  onSearch: _ctx.handleChange,
                  "filter-option": _ctx.filterOption,
                  "show-search": "",
                  onPopupScroll: _ctx.handlePopupScroll
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobData, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.name + index,
                        value: item.position_id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onChange", "onSearch", "filter-option", "onPopupScroll"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "职位",
                  value: _ctx.searches.position_name,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searches.position_name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "薪资范围",
                  value: _ctx.searches.wages_start,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searches.wages_start) = $event)),
                  style: {"width":"200px"}
                }, null, 8, ["value"]),
                _hoisted_10,
                _createVNode(_component_a_input, {
                  style: {"width":"200px","margin-left":"10px"},
                  placeholder: "薪资范围",
                  value: _ctx.searches.wages_end,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searches.wages_end) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.onSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { onClick: _ctx.onReset }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          loading: _ctx.loading,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'wages')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(record.wages_start / 1000) + "k——" + _toDisplayString(record.wages_end / 1000) + "k", 1))
              : _createCommentVNode("", true),
            (column.key === 'work_age')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(record.work_age) + "年 ", 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'expectWorks')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(record.expectWorks, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    style: {"margin-right":"20px"}
                  }, _toDisplayString(item.position_name), 1))
                }), 128))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: ($event: any) => (_ctx.getDetail(record)),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: ($event: any) => (_ctx.preview(record)),
                    size: "small",
                    style: {"margin-left":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: ($event: any) => (_ctx.exportResume(record)),
                    size: "small",
                    style: {"margin-left":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该简历?",
                    onConfirm: ($event: any) => (_ctx.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        size: "small",
                        style: {"margin-left":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible) = $event)),
      title: "简历详情",
      width: "60%",
      footer: null
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_18,
          _hoisted_19,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.detailData.name), 1),
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.detailData.work_age) + "年", 1),
              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.detailData.email), 1),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.detailData.address), 1),
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.detailData.advantage), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _hoisted_28,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.educations, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_31, _toDisplayString(item.major), 1),
                _createElementVNode("div", _hoisted_32, _toDisplayString(item.degree_text), 1),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.describe), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { type: "link" }, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_35, _toDisplayString(item.start_time) + "——" + _toDisplayString(item.end_time), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _hoisted_38,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.expectWorks, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, _toDisplayString(item.position_name), 1),
                _createElementVNode("div", _hoisted_41, _toDisplayString(item.wages_start / 1000) + "k-" + _toDisplayString(item.wages_end / 1000) + "k", 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(item.province_name) + _toDisplayString(item.city_name), 1),
                _createElementVNode("div", _hoisted_43, _toDisplayString(item.industry_name), 1),
                _createElementVNode("div", _hoisted_44, _toDisplayString(item.create_time), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _hoisted_47,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.workExperiences, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, _toDisplayString(item.company_name), 1),
                _createElementVNode("div", _hoisted_50, _toDisplayString(item.position_name), 1),
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.work_content), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { type: "link" }, {
                        default: _withCtx(() => [
                          _hoisted_52
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_53, _toDisplayString(item.work_start), 1),
                _createElementVNode("div", _hoisted_54, _toDisplayString(item.work_end), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _hoisted_57,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.projects, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_60, _toDisplayString(item.role), 1),
                _createElementVNode("div", _hoisted_61, _toDisplayString(item.achievement), 1),
                _createElementVNode("div", _hoisted_62, [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.describe), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { type: "link" }, {
                        default: _withCtx(() => [
                          _hoisted_63
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_64, _toDisplayString(item.start_time), 1),
                _createElementVNode("div", _hoisted_65, _toDisplayString(item.end_time), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_66, [
          _hoisted_67,
          _hoisted_68,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.certificate, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, _toDisplayString(item.id), 1),
                _createElementVNode("div", _hoisted_71, _toDisplayString(item.name), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible2,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visible2) = $event)),
      title: "上传简历",
      onOk: _ctx.handleOk,
      footer: null,
      width: "30%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_upload_dragger, {
          name: "word",
          "file-list": _ctx.fileList,
          class: "avatar-uploader",
          headers: _ctx.uploadHeaders,
          action: _ctx.uploadAction,
          data: _ctx.uploadFormData,
          onChange: _ctx.handleChange2,
          "show-upload-list": false
        }, {
          default: _withCtx(() => [
            _hoisted_72,
            _hoisted_73
          ]),
          _: 1
        }, 8, ["file-list", "headers", "action", "data", "onChange"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}